import { Sparkles, RefreshCw, Zap, Pause, XCircle, CheckCircle2 } from 'lucide-react';

import { fmtClock, fmtRelative } from '../utils/format';

const MODE_ICON = {
  create: { Icon: Sparkles, className: 'text-greenColor' },
  enrich: { Icon: RefreshCw, className: 'text-darkBlueColor' },
  overwrite: { Icon: Zap, className: 'text-orangeColor' },
  skip: { Icon: Pause, className: 'text-darkGrayColor' },
  skipped: { Icon: Pause, className: 'text-darkGrayColor' },
  failed: { Icon: XCircle, className: 'text-redColor' },
};

const fallbackSpec = { Icon: CheckCircle2, className: 'text-purpleColor' };

// One row in the recent activity feed.
export const ActivityFeedItem = ({ item }) => {
  const spec = MODE_ICON[item.mode] || fallbackSpec;
  const { Icon } = spec;
  const fields = Array.isArray(item.fields_touched) ? item.fields_touched : [];

  return (
    <li
      className="flex items-start gap-2 px-2.5 py-1.5 rounded border border-gray-100 bg-white hover:bg-lightestGrayColor transition-colors"
    >
      <Icon size={14} className={spec.className + ' mt-0.5 flex-shrink-0'} />
      <div className="flex-1 min-w-0">
        <div className="flex items-baseline justify-between gap-2">
          <span className="text-xs font-medium text-blackColor truncate">
            realty #{item.realty_id}
          </span>
          <span
            className="text-[10px] text-darkGrayColor whitespace-nowrap"
            title={fmtClock(item.applied_at)}
          >
            {fmtRelative(item.applied_at)} ago
          </span>
        </div>
        <div className="flex flex-wrap items-center gap-1.5 mt-0.5">
          <span className={'text-[10px] font-medium ' + spec.className}>
            {item.mode}
          </span>
          {item.batch_id != null && (
            <span className="text-[10px] text-darkGrayColor">
              · batch #{item.batch_id}
            </span>
          )}
          {fields.slice(0, 4).map(f => (
            <span
              key={f}
              className="inline-flex items-center px-1.5 py-0.5 rounded bg-lightGrayColor text-[10px] text-darkGrayColor"
            >
              {f}
            </span>
          ))}
          {fields.length > 4 && (
            <span className="text-[10px] text-darkGrayColor">
              +{fields.length - 4}
            </span>
          )}
        </div>
      </div>
    </li>
  );
};

export const ActivityFeed = ({ items = [] }) => {
  if (!items.length) {
    return (
      <div className="flex flex-col items-center gap-2 py-8 text-xs text-darkGrayColor">
        <Sparkles size={18} className="text-lightGrayColor" />
        <span>No recent activity.</span>
      </div>
    );
  }
  return (
    <ul className="flex flex-col gap-1.5 max-h-80 overflow-y-auto pr-1">
      {items.map((item, idx) => (
        <ActivityFeedItem
          key={`${item.realty_id}-${item.applied_at}-${idx}`}
          item={item}
        />
      ))}
    </ul>
  );
};
